module.exports = __webpack_public_path__ + "img/weapp-header-light.d1838332.png";